// extracted by mini-css-extract-plugin
export default {"root":"FieldRequiredIndicator_root__6XzBn","asterisk":"FieldRequiredIndicator_asterisk__N6R0z","srOnly":"FieldRequiredIndicator_srOnly__nJIL5"};